export const PAGE_SIZE = 10;
export const MULTISELECT_PAGE_SIZE = 300;